import { getGreatestNumberCoinsInTubes } from './getGreatestNumberCoinsInTubes';

export const getCoinMechCapacities = (machineCoinMech, tubesDetail = null) => {

	if (!machineCoinMech?.settings) {
		return getGreatestNumberCoinsInTubes(tubesDetail);
	}

	return Object.keys(machineCoinMech.settings.coinMechCapacities).reduce((acc, coinValue) => {
		// every value should be in coinMech
		acc[coinValue] = machineCoinMech.settings.coinMechCapacities && machineCoinMech.settings.coinMechCapacities[coinValue];
		return acc;
	}, {});
};
